import React, { Fragment } from "react";
import { useEffect } from "react";

import { useConfig } from "../../core/config";
import { useAnalytics } from "../../lib/analytics/analytics";
import { makeGA4Client } from "../../lib/analytics/ga4";
import { makeOneSignalClient } from "@/lib/analytics/onesignal";
import { OneSignalConfig } from "@/lib/analytics/onesignal";
import { useInitializeOneSignalFeatureFlag } from "@/core/splitio";

export function useWerqwiseAnalytics() {
  const config = useConfig();
  const analytics = useAnalytics();
  const initializeOneSignalFeatureFlag = useInitializeOneSignalFeatureFlag();

  useEffect(() => {
    const variables = envVariables[config.environment];

    if (variables.ga4TrackingId) {
      const ga4Client = makeGA4Client({
        trackingId: variables.ga4TrackingId,
        gaOptions: {
          name: "werqwise",
        },
      });

      analytics.addClient(ga4Client);
    }

    if (variables.oneSignalAppId && initializeOneSignalFeatureFlag) {
      const oneSignalConfig: Partial<OneSignalConfig> & { appId: string } = {
        appId: variables.oneSignalAppId,
        showPromoCode: true,
        promoCodeText: "WELCOMETOWERQWISE",
      };
      const oneSignalClient = makeOneSignalClient(oneSignalConfig);
      analytics.addClient(oneSignalClient);
    }
  }, [analytics, config.environment, initializeOneSignalFeatureFlag]);
}

const envVariables = {
  development: {
    ga4TrackingId: "",
    oneSignalAppId: "",
  },
  staging: {
    ga4TrackingId: "G-WPQRTG3JSZ",
    oneSignalAppId: "ae06a7d5-677c-4545-9064-4e5e5efb8be3",
  },
  production: {
    ga4TrackingId: "G-KZF09ERFJW",
    oneSignalAppId: "",
  },
};

export default function WerqwiseAnalytics(): JSX.Element {
  useWerqwiseAnalytics();

  return <Fragment></Fragment>;
}
